module.exports = __webpack_public_path__ + "img/23.85b7f3ca.png";